import * as React from 'react';

import { translate } from 'components/translate-hoc';
import { FR_FRIEND_LIST_TEXT_KEYS } from '../fr-friend-list-common';
import './fr-friend-list-no-friends.styles.less';
import { IFRFriendListNoFriendsTypes } from './fr-friend-list-no-friends.types';
import { getModeClass } from 'utils/css';

export class FRFriendListNoFriends extends React.Component<IFRFriendListNoFriendsTypes> {
    public render(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, shouldInheritStyles } = this.props;
        const basePageStyleClass = getModeClass('sitegen-fr-friend-list', shouldInheritStyles);
        const friendsStyleClass = getModeClass('sitegen-fr-friend-list-no-friends', shouldInheritStyles);

        return (
            <div className={`${basePageStyleClass} ${friendsStyleClass}`}>
                <div className={`${friendsStyleClass}__header`}>
                    <div className={`${friendsStyleClass}__title`}>
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.INVITE_FRIENDS)}
                    </div>
                </div>

                <div className={`${friendsStyleClass}__content`}>
                    <div className={`${friendsStyleClass}__title`}>
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.NO_FRIENDS_TITLE)}
                    </div>

                    <div className={`${friendsStyleClass}__suggestion`}>
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.NO_FRIENDS_SUGGESTION)}
                    </div>
                </div>

                <div className={`${friendsStyleClass}__footer`}>
                    <div className={`${friendsStyleClass}__action-button`}>
                        {translateKey(FR_FRIEND_LIST_TEXT_KEYS.INVITE_FRIENDS)}
                    </div>
                </div>
            </div>
        );
    }
}

export const FRFriendListNoFriendsWithTranslations = translate()(FRFriendListNoFriends);
